/**
 * Updates low-stock messaging when the customer changes variants (Atlantic / shopify-variants).
 */
(function () {
  if (!window.jQuery) {
    return;
  }

  var $ = window.jQuery;

  function formatMessage(template, qty) {
    var t = template || '';
    return t.split('{qty}').join(String(qty));
  }

  function shouldShow(tracked, available, qty, threshold) {
    var th = parseInt(threshold, 10);
    if (!tracked || !available || !th || th <= 0) {
      return false;
    }
    return qty > 0 && qty < th;
  }

  function getConfig($wrap) {
    var cached = $wrap.data('lowStockConfig');
    if (cached) {
      return cached;
    }
    var el = $wrap.find('script[data-low-stock-config]')[0];
    if (!el) {
      return null;
    }
    try {
      var cfg = JSON.parse(el.textContent);
      $wrap.data('lowStockConfig', cfg);
      return cfg;
    } catch (e) {
      return null;
    }
  }

  function applyVariant($wrap, variant) {
    var cfg = getConfig($wrap);
    var $text = $wrap.find('[data-low-stock-text]');
    if (!cfg || !$text.length) {
      return;
    }

    if (!variant || !variant.id) {
      $text.addClass('hidden').empty().removeAttr('aria-live');
      return;
    }

    var row = cfg.variants && cfg.variants[String(variant.id)];
    if (!row) {
      $text.addClass('hidden').empty().removeAttr('aria-live');
      return;
    }

    if (shouldShow(row.tracked, row.available, row.q, cfg.threshold)) {
      $text
        .text(formatMessage(cfg.template, row.q))
        .removeClass('hidden')
        .attr('aria-live', 'polite');
    } else {
      $text.addClass('hidden').empty().removeAttr('aria-live');
    }
  }

  function onVariantSwitch(event, data) {
    if (!data || !data.product) {
      return;
    }
    var pid = data.product.id;
    $('.low-stock-messaging[data-low-stock]').each(function () {
      var $wrap = $(this);
      if (parseInt($wrap.attr('data-product-id'), 10) !== pid) {
        return;
      }
      applyVariant($wrap, data.variant);
    });
  }

  $(function () {
    $(window).on('shopify-variants:switch-variant.lowStockMessaging', onVariantSwitch);
  });
})();
